const GridIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.50008 18.568H12.5001C16.6667 18.568 18.3334 16.9014 18.3334 12.7347V7.7347C18.3334 3.56803 16.6667 1.90137 12.5001 1.90137H7.50008C3.33341 1.90137 1.66675 3.56803 1.66675 7.7347V12.7347C1.66675 16.9014 3.33341 18.568 7.50008 18.568Z"
      stroke="#91A2BB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33325 1.90137V18.568"
      stroke="#91A2BB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33325 10.2344H18.3333"
      stroke="#91A2BB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default GridIcon;
